"use strict";
// MA: Movement Allowance
// ST : Strength
// AG: Agility
// AV: Armour Value
Object.defineProperty(exports, "__esModule", { value: true });
exports.RACE = exports.getCareers = exports.CAREER_VERSION = exports.CAREER_ID = exports.AVATAR = void 0;
const skill_1 = require("./skill");
var RACE;
(function (RACE) {
    RACE["AMAZON_CAREER"] = "amazon-career";
    RACE["CHAOS_CAREER"] = "chaos-career";
    RACE["CHAOS_DWARF_CAREER"] = "chaos-dwarf-career";
    RACE["DARK_ELFE_CAREER"] = "dark-elfe-career";
    RACE["DWARF_CAREER"] = "dwarf-career";
    RACE["ELVEN_UNION_CAREER"] = "elven-union-career";
    RACE["GOBELIN_CAREER"] = "gobelin-career";
    RACE["HALFLING_CAREER"] = "halfling-career";
    RACE["HIGH_ELF_CAREER"] = "high-elf-career";
    RACE["HUMAN_CAREER"] = "human-career";
    RACE["IMPERIAL_CAREER"] = "imperial-career";
    RACE["KHORNE_CAREER"] = "khorne-career";
    RACE["LIZARDMEN_CAREER"] = "lizardmen-career";
    RACE["NECROMANTIC_CAREER"] = "necromantic-career";
    RACE["NORSE_CAREER"] = "norse-career";
    RACE["NURGLE_CAREER"] = "nurgle-career";
    RACE["ORC_CAREER"] = "orc-career";
    RACE["RAT_CAREER"] = "rat-career";
    RACE["SILVAN_CAREER"] = "silvan-career";
    RACE["SLANN_CAREER"] = "slann-career";
    RACE["SNOTLING_CAREER"] = "snotling-career";
    RACE["UNDEAD_CAREER"] = "undead-career";
    RACE["VAMPIRE_CAREER"] = "vampire-career";
})(RACE || (exports.RACE = RACE = {}));
var AVATAR;
(function (AVATAR) {
    AVATAR["BEASTMAN"] = "beastman";
    AVATAR["BLACK_ORC"] = "black-orc";
    AVATAR["BLOATER"] = "bloater";
    AVATAR["BLOODSPAWN"] = "bloodspawn";
    AVATAR["CENTAUR"] = "centaur";
    AVATAR["CHAOS_DWARF"] = "chaos-dwarf";
    AVATAR["CHAOS_WARRIOR"] = "chaos-warrior";
    AVATAR["DARK_ELF"] = "dark_elf";
    AVATAR["DWARF"] = "dwarf";
    AVATAR["ELF"] = "elf";
    AVATAR["GOBELIN"] = "gobelin";
    AVATAR["GOLEM"] = "golem";
    AVATAR["HALFING"] = "halfing";
    AVATAR["HUMAN_WOMAN"] = "human-woman";
    AVATAR["HUMAN"] = "human";
    AVATAR["LIZARDMEN"] = "lezard";
    AVATAR["MINOTAUR"] = "minotaur";
    AVATAR["MUMMIE"] = "mummie";
    AVATAR["OGRE"] = "ogre";
    AVATAR["ORC"] = "orc";
    AVATAR["RAT_OGRE"] = "rat_ogre";
    AVATAR["RAT"] = "rat";
    AVATAR["ROTSPAWN"] = "rotspawn";
    AVATAR["SLANN"] = "slann";
    AVATAR["TREEMAN"] = "treeman";
    AVATAR["TROLL"] = "troll";
    AVATAR["UNDEAD"] = "undead";
    AVATAR["VAMPIRE"] = "vampire";
    AVATAR["WAGON"] = "wagon";
    AVATAR["WEREWOLF"] = "werewolf";
    AVATAR["YHETEE"] = "yhetee";
})(AVATAR || (exports.AVATAR = AVATAR = {}));
var CAREER_ID;
(function (CAREER_ID) {
    CAREER_ID["AMAZON_BLITZER_2025"] = "amazon-blitzer-2025";
    CAREER_ID["AMAZON_BLOCKER_2025"] = "amazon-blocker-2025";
    CAREER_ID["AMAZON_LINEWOMAN_2025"] = "amazon-linewoman-2025";
    CAREER_ID["AMAZON_THROWER_2025"] = "amazon-thrower-2025";
    CAREER_ID["CHAOS_CHOSEN_BEASTMAN_2025"] = "chaos-chosen-beastman-2025";
    CAREER_ID["CHAOS_CHOSEN_CHOSEN_2025"] = "chaos-chosen-chosen-2025";
    CAREER_ID["CHAOS_CHOSEN_MINOTAUR_2025"] = "chaos-chosen-minotaur-2025";
    CAREER_ID["CHAOS_DWARF_BLOCKER_2025"] = "chaos-dwarf-blocker-2025";
    CAREER_ID["CHAOS_DWARF_BULL_CENTAUR_2025"] = "chaos-dwarf-bull-centaur-2025";
    CAREER_ID["CHAOS_DWARF_FLAMER_2025"] = "chaos-dwarf-flamer-2025";
    CAREER_ID["CHAOS_DWARF_HOBGOBLIN_2025"] = "chaos-dwarf-hobgoblin-2025";
    CAREER_ID["CHAOS_DWARF_MINOTAUR_2025"] = "chaos-dwarf-minotaur-2025";
    CAREER_ID["CHAOS_DWARF_STABBA_2025"] = "chaos-dwarf-stabba-2025";
    CAREER_ID["DARK_ELF_ASSASSIN_2025"] = "dark-elf-assassin-2025";
    CAREER_ID["DARK_ELF_BLITZER_2025"] = "dark-elf-blitzer-2025";
    CAREER_ID["DARK_ELF_LINEMAN_2025"] = "dark-elf-lineman-2025";
    CAREER_ID["DARK_ELF_RUNNER_2025"] = "dark-elf-runner-2025";
    CAREER_ID["DARK_ELF_WITCH_ELF_2025"] = "dark-elf-witch-elf-2025";
    CAREER_ID["DWARF_BLITZER_2025"] = "dwarf-blitzer-2025";
    CAREER_ID["DWARF_DEATHROLLER_2025"] = "dwarf-deathroller-2025";
    CAREER_ID["DWARF_LINEMAN_2025"] = "dwarf-lineman-2025";
    CAREER_ID["DWARF_RUNNER_2025"] = "dwarf-runner-2025";
    CAREER_ID["DWARF_TROLL_SLAYER_2025"] = "dwarf-troll-slayer-2025";
    CAREER_ID["ELVEN_UNION_BLITZER_2025"] = "elven-union-blitzer-2025";
    CAREER_ID["ELVEN_UNION_CATCHER_2025"] = "elven-union-catcher-2025";
    CAREER_ID["ELVEN_UNION_LINEMAN_2025"] = "elven-union-lineman-2025";
    CAREER_ID["ELVEN_UNION_THROWER_2025"] = "elven-union-thrower-2025";
    CAREER_ID["GOBLIN_DOOM_DIVER_2025"] = "goblin-doom-diver-2025";
    CAREER_ID["GOBLIN_LINEMAN_2025"] = "goblin-lineman-2025";
    CAREER_ID["GOBLIN_LOONY_2025"] = "goblin-loony-2025";
    CAREER_ID["GOBLIN_OOLIGAN_2025"] = "goblin-ooligan-2025";
    CAREER_ID["GOBLIN_POGOER_2025"] = "goblin-pogoer-2025";
    CAREER_ID["GOBLIN_TROLL_2025"] = "goblin-troll-2025";
    CAREER_ID["HALFLING_CATCHER_2025"] = "halfling-catcher-2025";
    CAREER_ID["HALFLING_HEFTY_2025"] = "halfling-hefty-2025";
    CAREER_ID["HALFLING_LINEMAN_2025"] = "halfling-lineman-2025";
    CAREER_ID["HALFLING_TREEMAN_2025"] = "halfling-treeman-2025";
    CAREER_ID["HIGH_ELF_BLITZER_2025"] = "high-elf-blitzer-2025";
    CAREER_ID["HIGH_ELF_CATCHER_2025"] = "high-elf-catcher-2025";
    CAREER_ID["HIGH_ELF_LINEMAN_2025"] = "high-elf-lineman-2025";
    CAREER_ID["HIGH_ELF_THROWER_2025"] = "high-elf-thrower-2025";
    CAREER_ID["HUMAN_BLITZER_2025"] = "human-blitzer-2025";
    CAREER_ID["HUMAN_CATCHER_2025"] = "human-catcher-2025";
    CAREER_ID["HUMAN_LINEMAN_2025"] = "human-lineman-2025";
    CAREER_ID["HUMAN_OGRE_2025"] = "human-ogre-2025";
    CAREER_ID["HUMAN_THROWER_2025"] = "human-thrower-2025";
    CAREER_ID["IMPERIAL_NOBILITY_BLITZER_2025"] = "imperial-nobility-blitzer-2025";
    CAREER_ID["IMPERIAL_NOBILITY_BODYGUARD_2025"] = "imperial-nobility-bodyguard-2025";
    CAREER_ID["IMPERIAL_NOBILITY_OGRE_2025"] = "imperial-nobility-ogre-2025";
    CAREER_ID["IMPERIAL_NOBILITY_RETAINER_2025"] = "imperial-nobility-retainer-2025";
    CAREER_ID["IMPERIAL_NOBILITY_THROWER_2025"] = "imperial-nobility-thrower-2025";
    CAREER_ID["KHORNE_BLOODSEEKER_2025"] = "khorne-bloodseeker-2025";
    CAREER_ID["KHORNE_BLOODSPAWN_2025"] = "khorne-bloodspawn-2025";
    CAREER_ID["KHORNE_KHORNGOR_2025"] = "khorne-khorngor-2025";
    CAREER_ID["KHORNE_MARAUDER_2025"] = "khorne-marauder-2025";
    CAREER_ID["LIZARDMEN_CHAMELEON_2025"] = "lizardmen-chameleon-2025";
    CAREER_ID["LIZARDMEN_KROXIGOR_2025"] = "lizardmen-kroxigor-2025";
    CAREER_ID["LIZARDMEN_SAURUS_2025"] = "lizardmen-saurus-2025";
    CAREER_ID["LIZARDMEN_SKINK_2025"] = "lizardmen-skink-2025";
    CAREER_ID["NECROMANTIC_HORROR_FLESH_GOLEM_2025"] = "necromantic-horror-flesh-golem-2025";
    CAREER_ID["NECROMANTIC_HORROR_GHOUL_2025"] = "necromantic-horror-ghoul-2025";
    CAREER_ID["NECROMANTIC_HORROR_WEREWOLF_2025"] = "necromantic-horror-werewolf-2025";
    CAREER_ID["NECROMANTIC_HORROR_WRAITH_2025"] = "necromantic-horror-wraith-2025";
    CAREER_ID["NECROMANTIC_HORROR_ZOMBIE_2025"] = "necromantic-horror-zombie-2025";
    CAREER_ID["NORSE_BERSERKER_2025"] = "norse-berserker-2025";
    CAREER_ID["NORSE_RAIDER_2025"] = "norse-raider-2025";
    CAREER_ID["NORSE_ULFWERNER_2025"] = "norse-ulfwerner-2025";
    CAREER_ID["NORSE_VALKYRIE_2025"] = "norse-valkyrie-2025";
    CAREER_ID["NORSE_YHETEE_2025"] = "norse-yhetee-2025";
    CAREER_ID["NURGLE_BLOATER_2025"] = "nurgle-bloater-2025";
    CAREER_ID["NURGLE_PESTIGOR_2025"] = "nurgle-pestigor-2025";
    CAREER_ID["NURGLE_ROTSPAWN_2025"] = "nurgle-rotspawn-2025";
    CAREER_ID["NURGLE_ROTTER_2025"] = "nurgle-rotter-2025";
    CAREER_ID["ORC_BIG_UN_2025"] = "orc-big-un-2025";
    CAREER_ID["ORC_BLITZER_2025"] = "orc-blitzer-2025";
    CAREER_ID["ORC_LINEMAN_2025"] = "orc-lineman-2025";
    CAREER_ID["ORC_THROWER_2025"] = "orc-thrower-2025";
    CAREER_ID["ORC_TROLL_2025"] = "orc-troll-2025";
    CAREER_ID["SHAMBLING_UNDEAD_GHOUL_2025"] = "shambling-undead-ghoul-2025";
    CAREER_ID["SHAMBLING_UNDEAD_MUMMY_2025"] = "shambling-undead-mummy-2025";
    CAREER_ID["SHAMBLING_UNDEAD_SKELETON_2025"] = "shambling-undead-skeleton-2025";
    CAREER_ID["SHAMBLING_UNDEAD_WIGHT_2025"] = "shambling-undead-wight-2025";
    CAREER_ID["SHAMBLING_UNDEAD_ZOMBIE_2025"] = "shambling-undead-zombie-2025";
    CAREER_ID["SKAVEN_BLITZER_2025"] = "skaven-blitzer-2025";
    CAREER_ID["SKAVEN_CLANRAT_2025"] = "skaven-clanrat-2025";
    CAREER_ID["SKAVEN_GUTTER_2025"] = "skaven-gutter-2025";
    CAREER_ID["SKAVEN_RAT_OGRE_2025"] = "skaven-rat-ogre-2025";
    CAREER_ID["SKAVEN_THROWER_2025"] = "skaven-thrower-2025";
    CAREER_ID["SLANN_BLITZER_2025"] = "slann-blitzer-2025";
    CAREER_ID["SLANN_CATCHER_2025"] = "slann-catcher-2025";
    CAREER_ID["SLANN_KROXIGOR_2025"] = "slann-kroxigor-2025";
    CAREER_ID["SLANN_LINEMAN_2025"] = "slann-lineman-2025";
    CAREER_ID["SNOTLING_HOPPA_2025"] = "snotling-hoppa-2025";
    CAREER_ID["SNOTLING_LINEMAN_2025"] = "snotling-lineman-2025";
    CAREER_ID["SNOTLING_PUMP_WAGON_2025"] = "snotling-pump-wagon-2025";
    CAREER_ID["SNOTLING_RUNNA_2025"] = "snotling-runna-2025";
    CAREER_ID["SNOTLING_TROLL_2025"] = "snotling-troll-2025";
    CAREER_ID["VAMPIRE_BLITZER_2025"] = "vampire-blitzer-2025";
    CAREER_ID["VAMPIRE_RUNNER_2025"] = "vampire-runner-2025";
    CAREER_ID["VAMPIRE_THRALL_2025"] = "vampire-thrall-2025";
    CAREER_ID["VAMPIRE_THROWER_2025"] = "vampire-thrower-2025";
    CAREER_ID["VAMPIRE_VARGHEIST_2025"] = "vampire-vargheist-2025";
    CAREER_ID["WOOD_ELF_CATCHER_2025"] = "wood-elf-catcher-2025";
    CAREER_ID["WOOD_ELF_LINEMAN_2025"] = "wood-elf-lineman-2025";
    CAREER_ID["WOOD_ELF_THROWER_2025"] = "wood-elf-thrower-2025";
    CAREER_ID["WOOD_ELF_WARDANCER_2025"] = "wood-elf-wardancer-2025";
})(CAREER_ID || (exports.CAREER_ID = CAREER_ID = {}));
var CAREER_VERSION;
(function (CAREER_VERSION) {
    CAREER_VERSION["V6"] = "v6";
    CAREER_VERSION["V2020"] = "v2020";
    CAREER_VERSION["V2025"] = "v2025";
})(CAREER_VERSION || (exports.CAREER_VERSION = CAREER_VERSION = {}));
const CAREER = {
    [CAREER_ID.AMAZON_LINEWOMAN_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 7,
        normal: "G",
        double: "AS",
        normalCoach: "G",
        icons: ["amazon-linewomen1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE
        ],
        avatars: [AVATAR.HUMAN_WOMAN],
        badge: RACE.AMAZON_CAREER,
        range: 0,
        cost: 50,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.AMAZON_THROWER_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "GP",
        double: "AS",
        normalCoach: "G",
        icons: ["amazon-thrower1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.ON_THE_BALL,
            skill_1.SKILL_NAMES.PASS,
            skill_1.SKILL_NAMES.SAFE_PASS,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN_WOMAN],
        badge: RACE.AMAZON_CAREER,
        range: 1,
        cost: 80,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.AMAZON_BLITZER_2025]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 7,
        normal: "AG",
        double: "S",
        normalCoach: "G",
        icons: ["amazon-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.HIT_AND_RUN,
            skill_1.SKILL_NAMES.JUMP_UP,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN_WOMAN],
        badge: RACE.AMAZON_CAREER,
        range: 2,
        cost: 90,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.AMAZON_BLOCKER_2025]: {
        MA: 6,
        ST: 4,
        AG: 3,
        PA: 2,
        AV: 8,
        normal: "GS",
        double: "A",
        normalCoach: "G",
        icons: ["amazon-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.DEFENSIVE,
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.STAR
        ],
        avatars: [AVATAR.HUMAN_WOMAN],
        badge: RACE.AMAZON_CAREER,
        range: 5,
        cost: 110,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.CHAOS_CHOSEN_BEASTMAN_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 8,
        normal: "GM",
        double: "ADPS",
        normalCoach: "G",
        icons: ["chaos-beastman1"],
        skills: [
            skill_1.SKILL_NAMES.HORNS,
            skill_1.SKILL_NAMES.THICK_SKULL
        ],
        avatars: [AVATAR.BEASTMAN],
        badge: RACE.CHAOS_CAREER,
        range: 0,
        cost: 55,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.CHAOS_CHOSEN_CHOSEN_2025]: {
        MA: 5,
        ST: 4,
        AG: 3,
        PA: 1,
        AV: 9,
        normal: "GMS",
        double: "AD",
        normalCoach: "G",
        icons: ["chaos-warrior1"],
        skills: [
            skill_1.SKILL_NAMES.ARM_BAR,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.CHAOS_CAREER,
        range: 1,
        cost: 100,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.CHAOS_CHOSEN_MINOTAUR_2025]: {
        MA: 5,
        ST: 5,
        AG: 2,
        PA: -1,
        AV: 8,
        normal: "MS",
        double: "AG",
        normalCoach: "G",
        icons: ["chaos-minotaur1"],
        skills: [
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.HORNS,
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.UNCHANNELLED_FURY,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.MINOTAUR],
        badge: RACE.CHAOS_CAREER,
        range: 6,
        cost: 150,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.CHAOS_DWARF_HOBGOBLIN_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 7,
        normal: "D",
        double: "AGS",
        normalCoach: "G",
        icons: ["chaos-dwarf-hobgobelin1"],
        skills: [],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.CHAOS_DWARF_CAREER,
        range: 0,
        cost: 40,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.CHAOS_DWARF_STABBA_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 1,
        AV: 7,
        normal: "DG",
        double: "AS",
        normalCoach: "G",
        icons: ["chaos-dwarf-hobgobelin1"],
        skills: [
            skill_1.SKILL_NAMES.SHADOWING,
            skill_1.SKILL_NAMES.STAB,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.CHAOS_DWARF_CAREER,
        range: 1,
        cost: 60,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.CHAOS_DWARF_BLOCKER_2025]: {
        MA: 4,
        ST: 3,
        AG: 2,
        PA: -1,
        AV: 9,
        normal: "GS",
        double: "ADM",
        normalCoach: "G",
        icons: ["chaos-dwarf-blocker1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.IRON_HARD_SKIN,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.DWARF],
        badge: RACE.CHAOS_DWARF_CAREER,
        range: 2,
        cost: 70,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.CHAOS_DWARF_FLAMER_2025]: {
        MA: 5,
        ST: 3,
        AG: 2,
        PA: -1,
        AV: 9,
        normal: "GS",
        double: "ADM",
        normalCoach: "G",
        icons: ["chaos-dwarf-blocker1"],
        skills: [
            skill_1.SKILL_NAMES.BRAWLER,
            skill_1.SKILL_NAMES.BREATHE_FIRE,
            skill_1.SKILL_NAMES.DISTURBING_PRESENCE,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.DWARF],
        badge: RACE.CHAOS_DWARF_CAREER,
        range: 3,
        cost: 80,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.CHAOS_DWARF_BULL_CENTAUR_2025]: {
        MA: 6,
        ST: 4,
        AG: 2,
        PA: -1,
        AV: 9,
        normal: "GS",
        double: "ADM",
        normalCoach: "G",
        icons: ["chaos-dwarf-bull-centaur1"],
        skills: [
            skill_1.SKILL_NAMES.SPRINT,
            skill_1.SKILL_NAMES.SURE_FEET,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.UNSTEADY,
            skill_1.SKILL_NAMES.STAR
        ],
        avatars: [AVATAR.DWARF],
        badge: RACE.CHAOS_DWARF_CAREER,
        range: 5,
        cost: 130,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.CHAOS_DWARF_MINOTAUR_2025]: {
        MA: 5,
        ST: 5,
        AG: 2,
        PA: -1,
        AV: 8,
        normal: "MS",
        double: "AG",
        normalCoach: "G",
        icons: ["chaos-minotaur1"],
        skills: [
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.HORNS,
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.UNCHANNELLED_FURY,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.MINOTAUR],
        badge: RACE.CHAOS_DWARF_CAREER,
        range: 6,
        cost: 150,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.DARK_ELF_LINEMAN_2025]: {
        MA: 6,
        ST: 3,
        AG: 4,
        PA: 3,
        AV: 8,
        normal: "AG",
        double: "DS",
        normalCoach: "G",
        icons: ["dark-elfe-lineman1"],
        skills: [],
        avatars: [AVATAR.ELF],
        badge: RACE.DARK_ELFE_CAREER,
        range: 0,
        cost: 65,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.DARK_ELF_RUNNER_2025]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 3,
        AV: 7,
        normal: "AGP",
        double: "DS",
        normalCoach: "G",
        icons: ["dark-elfe-runner1"],
        skills: [
            skill_1.SKILL_NAMES.DUMP_OFF,
            skill_1.SKILL_NAMES.PUNT,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.DARK_ELFE_CAREER,
        range: 1,
        cost: 80,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.DARK_ELF_ASSASSIN_2025]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 2,
        AV: 7,
        normal: "AD",
        double: "GS",
        normalCoach: "G",
        icons: ["dark-elfe-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.HIT_AND_RUN,
            skill_1.SKILL_NAMES.SHADOWING,
            skill_1.SKILL_NAMES.STAB,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.DARK_ELFE_CAREER,
        range: 2,
        cost: 90,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.DARK_ELF_BLITZER_2025]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 3,
        AV: 8,
        normal: "AG",
        double: "DPS",
        normalCoach: "G",
        icons: ["dark-elfe-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.DARK_ELFE_CAREER,
        range: 3,
        cost: 105,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.DARK_ELF_WITCH_ELF_2025]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 2,
        AV: 7,
        normal: "AG",
        double: "DS",
        normalCoach: "G",
        icons: ["dark-elfe-witch1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.JUMP_UP,
            skill_1.SKILL_NAMES.STAR
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.DARK_ELFE_CAREER,
        range: 5,
        cost: 110,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.DWARF_LINEMAN_2025]: {
        MA: 4,
        ST: 3,
        AG: 2,
        PA: 1,
        AV: 9,
        normal: "DG",
        double: "S",
        normalCoach: "G",
        icons: ["dwarf1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.DEFENSIVE,
            skill_1.SKILL_NAMES.THICK_SKULL
        ],
        avatars: [AVATAR.DWARF],
        badge: RACE.DWARF_CAREER,
        range: 0,
        cost: 70,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.DWARF_RUNNER_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 8,
        normal: "GP",
        double: "S",
        normalCoach: "G",
        icons: ["dwarf-runner1"],
        skills: [
            skill_1.SKILL_NAMES.SPRINT,
            skill_1.SKILL_NAMES.SURE_HANDS,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.DWARF],
        badge: RACE.DWARF_CAREER,
        range: 1,
        cost: 80,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.DWARF_BLITZER_2025]: {
        MA: 5,
        ST: 3,
        AG: 2,
        PA: 2,
        AV: 9,
        normal: "GS",
        double: "P",
        normalCoach: "G",
        icons: ["dwarf-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.DIVING_TACKLE,
            skill_1.SKILL_NAMES.TACKLE,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.DWARF],
        badge: RACE.DWARF_CAREER,
        range: 3,
        cost: 100,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.DWARF_TROLL_SLAYER_2025]: {
        MA: 5,
        ST: 3,
        AG: 2,
        PA: 1,
        AV: 8,
        normal: "GS",
        double: "D",
        normalCoach: "G",
        icons: ["dwarf-troll-slayer1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.DAUNTLESS,
            skill_1.SKILL_NAMES.FRENZY,
            // SKILL_NAMES.HATRED_TROLL, // TODO: Ajouter HATRED_TROLL = "hatred-troll" dans skill.ts,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.DWARF],
        badge: RACE.DWARF_CAREER,
        range: 2,
        cost: 95,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.DWARF_DEATHROLLER_2025]: {
        MA: 4,
        ST: 7,
        AG: 1,
        PA: -1,
        AV: 10,
        normal: "DS",
        double: "G",
        normalCoach: "G",
        icons: ["dwarf-deathroller1"],
        skills: [
            skill_1.SKILL_NAMES.BREAK_TACKLE,
            skill_1.SKILL_NAMES.DIRTY_PLAYER,
            skill_1.SKILL_NAMES.JUGGERNAUT,
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.NO_HANDS,
            skill_1.SKILL_NAMES.SECRET_WEAPON,
            skill_1.SKILL_NAMES.STAND_FIRM,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.DWARF],
        badge: RACE.DWARF_CAREER,
        range: 6,
        cost: 170,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.ELVEN_UNION_LINEMAN_2025]: {
        MA: 6,
        ST: 3,
        AG: 4,
        PA: 3,
        AV: 7,
        normal: "AG",
        double: "S",
        normalCoach: "G",
        icons: ["elven-union-lineman1"],
        skills: [
            skill_1.SKILL_NAMES.FUMBLEROOSKIE
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.ELVEN_UNION_CAREER,
        range: 0,
        cost: 65,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.ELVEN_UNION_THROWER_2025]: {
        MA: 6,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "AGP",
        double: "S",
        normalCoach: "G",
        icons: ["elven-union-thrower1"],
        skills: [
            skill_1.SKILL_NAMES.HAIL_MARY_PASS,
            skill_1.SKILL_NAMES.PASS,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.ELVEN_UNION_CAREER,
        range: 1,
        cost: 75,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.ELVEN_UNION_CATCHER_2025]: {
        MA: 8,
        ST: 3,
        AG: 4,
        PA: 2,
        AV: 7,
        normal: "AG",
        double: "S",
        normalCoach: "G",
        icons: ["elven-union-catcher1"],
        skills: [
            skill_1.SKILL_NAMES.CATCH,
            skill_1.SKILL_NAMES.DIVING_CATCH,
            skill_1.SKILL_NAMES.NERVES_OF_STEEL,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.ELVEN_UNION_CAREER,
        range: 2,
        cost: 100,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.ELVEN_UNION_BLITZER_2025]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 3,
        AV: 8,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["elven-union-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.SIDESTEP,
            skill_1.SKILL_NAMES.STAR
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.ELVEN_UNION_CAREER,
        range: 5,
        cost: 115,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.GOBLIN_LINEMAN_2025]: {
        MA: 6,
        ST: 2,
        AG: 3,
        PA: 2,
        AV: 7,
        normal: "AD",
        double: "GPS",
        normalCoach: "G",
        icons: ["gobelin-lineman1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.RIGHT_STUFF,
            skill_1.SKILL_NAMES.STUNTY
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.GOBELIN_CAREER,
        range: 0,
        cost: 40,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.GOBLIN_LOONY_2025]: {
        MA: 6,
        ST: 2,
        AG: 3,
        PA: -1,
        AV: 7,
        normal: "D",
        double: "AGS",
        normalCoach: "G",
        icons: ["gobelin-looney1"],
        skills: [
            skill_1.SKILL_NAMES.CHAINSAW,
            skill_1.SKILL_NAMES.NO_HANDS,
            skill_1.SKILL_NAMES.SECRET_WEAPON,
            skill_1.SKILL_NAMES.STUNTY,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.GOBELIN_CAREER,
        range: 1,
        cost: 40,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.GOBLIN_OOLIGAN_2025]: {
        MA: 6,
        ST: 2,
        AG: 3,
        PA: 1,
        AV: 7,
        normal: "AD",
        double: "GS",
        normalCoach: "G",
        icons: ["gobelin-lineman1"],
        skills: [
            skill_1.SKILL_NAMES.DIRTY_PLAYER,
            skill_1.SKILL_NAMES.DISTURBING_PRESENCE,
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.RIGHT_STUFF,
            skill_1.SKILL_NAMES.STUNTY,
            skill_1.SKILL_NAMES.TAUNT,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.GOBELIN_CAREER,
        range: 2,
        cost: 60,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.GOBLIN_DOOM_DIVER_2025]: {
        MA: 6,
        ST: 2,
        AG: 3,
        PA: -1,
        AV: 7,
        normal: "A",
        double: "DGS",
        normalCoach: "G",
        icons: ["gobelin-pogoer1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.RIGHT_STUFF,
            skill_1.SKILL_NAMES.STUNTY,
            skill_1.SKILL_NAMES.SWOOP,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.GOBELIN_CAREER,
        range: 3,
        cost: 65,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.GOBLIN_POGOER_2025]: {
        MA: 7,
        ST: 2,
        AG: 3,
        PA: 2,
        AV: 7,
        normal: "A",
        double: "DGS",
        normalCoach: "G",
        icons: ["gobelin-pogoer1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.POGO_STICK,
            skill_1.SKILL_NAMES.STUNTY,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.GOBELIN_CAREER,
        range: 4,
        cost: 75,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.GOBLIN_TROLL_2025]: {
        MA: 4,
        ST: 5,
        AG: 1,
        PA: 1,
        AV: 9,
        normal: "S",
        double: "AGP",
        normalCoach: "G",
        icons: ["gobelin-troll1"],
        skills: [
            skill_1.SKILL_NAMES.ALWAYS_HUNGRY,
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.PROJECTILE_VOMIT,
            skill_1.SKILL_NAMES.REALLY_STUPID,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.THROW_TEAM_MATE,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.TROLL],
        badge: RACE.GOBELIN_CAREER,
        range: 6,
        cost: 115,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HALFLING_LINEMAN_2025]: {
        MA: 5,
        ST: 2,
        AG: 3,
        PA: 2,
        AV: 6,
        normal: "A",
        double: "DGS",
        normalCoach: "G",
        icons: ["halfling-lineman1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.RIGHT_STUFF,
            skill_1.SKILL_NAMES.STUNTY
        ],
        avatars: [AVATAR.HALFING],
        badge: RACE.HALFLING_CAREER,
        range: 0,
        cost: 30,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HALFLING_HEFTY_2025]: {
        MA: 5,
        ST: 2,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "AP",
        double: "DGS",
        normalCoach: "G",
        icons: ["halfling-hefty1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.FEND,
            skill_1.SKILL_NAMES.STUNTY,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HALFING],
        badge: RACE.HALFLING_CAREER,
        range: 1,
        cost: 50,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HALFLING_CATCHER_2025]: {
        MA: 5,
        ST: 2,
        AG: 3,
        PA: 2,
        AV: 6,
        normal: "A",
        double: "DGS",
        normalCoach: "G",
        icons: ["halfling-catcher1"],
        skills: [
            skill_1.SKILL_NAMES.CATCH,
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.RIGHT_STUFF,
            skill_1.SKILL_NAMES.SPRINT,
            skill_1.SKILL_NAMES.STUNTY,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HALFING],
        badge: RACE.HALFLING_CAREER,
        range: 2,
        cost: 55,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HALFLING_TREEMAN_2025]: {
        MA: 2,
        ST: 6,
        AG: 1,
        PA: 1,
        AV: 10,
        normal: "S",
        double: "AGP",
        normalCoach: "G",
        icons: ["halfling-treeman1"],
        skills: [
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.STAND_FIRM,
            skill_1.SKILL_NAMES.STRONG_ARM,
            skill_1.SKILL_NAMES.TAKE_ROOT,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.THROW_TEAM_MATE,
            skill_1.SKILL_NAMES.TIMMM_BER,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.TREEMAN],
        badge: RACE.HALFLING_CAREER,
        range: 6,
        cost: 120,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HIGH_ELF_LINEMAN_2025]: {
        MA: 6,
        ST: 3,
        AG: 4,
        PA: 3,
        AV: 8,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["elven-union-lineman1"],
        skills: [],
        avatars: [AVATAR.ELF],
        badge: RACE.HIGH_ELF_CAREER,
        range: 0,
        cost: 65,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HIGH_ELF_THROWER_2025]: {
        MA: 6,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 8,
        normal: "AGP",
        double: "S",
        normalCoach: "G",
        icons: ["elven-union-thrower1"],
        skills: [
            skill_1.SKILL_NAMES.CLOUD_BURSTER,
            skill_1.SKILL_NAMES.PASS,
            skill_1.SKILL_NAMES.SAFE_PASS,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.HIGH_ELF_CAREER,
        range: 2,
        cost: 100,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HIGH_ELF_CATCHER_2025]: {
        MA: 8,
        ST: 3,
        AG: 4,
        PA: 3,
        AV: 7,
        normal: "AG",
        double: "S",
        normalCoach: "G",
        icons: ["elven-union-catcher1"],
        skills: [
            skill_1.SKILL_NAMES.CATCH,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.HIGH_ELF_CAREER,
        range: 1,
        cost: 90,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HIGH_ELF_BLITZER_2025]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 2,
        AV: 8,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["elven-union-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.HIGH_ELF_CAREER,
        range: 3,
        cost: 100,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HUMAN_LINEMAN_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 8,
        normal: "G",
        double: "ADS",
        normalCoach: "G",
        icons: ["human1"],
        skills: [],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.HUMAN_CAREER,
        range: 0,
        cost: 50,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HUMAN_CATCHER_2025]: {
        MA: 8,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 7,
        normal: "AG",
        double: "DPS",
        normalCoach: "G",
        icons: ["human-catcher1"],
        skills: [
            skill_1.SKILL_NAMES.CATCH,
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.HUMAN_CAREER,
        range: 1,
        cost: 75,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HUMAN_THROWER_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GP",
        double: "ADS",
        normalCoach: "G",
        icons: ["human-thrower1"],
        skills: [
            skill_1.SKILL_NAMES.PASS,
            skill_1.SKILL_NAMES.SURE_HANDS,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.HUMAN_CAREER,
        range: 2,
        cost: 75,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HUMAN_BLITZER_2025]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 8,
        normal: "GS",
        double: "AD",
        normalCoach: "G",
        icons: ["human-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.TACKLE,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.HUMAN_CAREER,
        range: 3,
        cost: 85,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.HUMAN_OGRE_2025]: {
        MA: 5,
        ST: 5,
        AG: 2,
        PA: 1,
        AV: 9,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["human-ogre1"],
        skills: [
            skill_1.SKILL_NAMES.BONE_HEAD,
            [skill_1.SKILL_NAMES.LONER, 3],
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.THROW_TEAM_MATE,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.OGRE],
        badge: RACE.HUMAN_CAREER,
        range: 6,
        cost: 140,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.IMPERIAL_NOBILITY_RETAINER_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 7,
        normal: "G",
        double: "AS",
        normalCoach: "G",
        icons: ["imperial-lineman1"],
        skills: [
            skill_1.SKILL_NAMES.FEND
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.IMPERIAL_CAREER,
        range: 0,
        cost: 45,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.IMPERIAL_NOBILITY_THROWER_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 4,
        AV: 8,
        normal: "GP",
        double: "AS",
        normalCoach: "G",
        icons: ["imperial-thrower1"],
        skills: [
            skill_1.SKILL_NAMES.GIVE_AND_GO,
            skill_1.SKILL_NAMES.PASS,
            skill_1.SKILL_NAMES.PRO,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.IMPERIAL_CAREER,
        range: 1,
        cost: 75,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.IMPERIAL_NOBILITY_BODYGUARD_2025]: {
        MA: 5,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 8,
        normal: "GS",
        double: "A",
        normalCoach: "G",
        icons: ["imperial-bodyguard1"],
        skills: [
            skill_1.SKILL_NAMES.STAND_FIRM,
            skill_1.SKILL_NAMES.WRESTLE,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.IMPERIAL_CAREER,
        range: 2,
        cost: 85,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.IMPERIAL_NOBILITY_BLITZER_2025]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 8,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["imperial-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.CATCH,
            skill_1.SKILL_NAMES.PRO,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.IMPERIAL_CAREER,
        range: 3,
        cost: 90,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.IMPERIAL_NOBILITY_OGRE_2025]: {
        MA: 5,
        ST: 5,
        AG: 2,
        PA: 1,
        AV: 9,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["imperial-ogre1"],
        skills: [
            skill_1.SKILL_NAMES.BONE_HEAD,
            [skill_1.SKILL_NAMES.LONER, 3],
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.THROW_TEAM_MATE,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.OGRE],
        badge: RACE.IMPERIAL_CAREER,
        range: 6,
        cost: 140,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.KHORNE_MARAUDER_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 7,
        normal: "GM",
        double: "ADS",
        normalCoach: "G",
        icons: ["khorne-lineman1"],
        skills: [
            skill_1.SKILL_NAMES.FRENZY
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.KHORNE_CAREER,
        range: 0,
        cost: 50,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.KHORNE_KHORNGOR_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 8,
        normal: "GMS",
        double: "ADP",
        normalCoach: "G",
        icons: ["khorne-khorngor1"],
        skills: [
            skill_1.SKILL_NAMES.HORNS,
            skill_1.SKILL_NAMES.JUGGERNAUT,
            skill_1.SKILL_NAMES.JUMP_UP,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.BEASTMAN],
        badge: RACE.KHORNE_CAREER,
        range: 1,
        cost: 70,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.KHORNE_BLOODSEEKER_2025]: {
        MA: 5,
        ST: 4,
        AG: 2,
        PA: -1,
        AV: 9,
        normal: "GMS",
        double: "AD",
        normalCoach: "G",
        icons: ["khorne-bloodseeker1"],
        skills: [
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.STAR
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.KHORNE_CAREER,
        range: 5,
        cost: 105,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.KHORNE_BLOODSPAWN_2025]: {
        MA: 5,
        ST: 5,
        AG: 2,
        PA: -1,
        AV: 8,
        normal: "MS",
        double: "AG",
        normalCoach: "G",
        icons: ["khorne-bloodspawn1"],
        skills: [
            skill_1.SKILL_NAMES.CLAW,
            skill_1.SKILL_NAMES.FRENZY,
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.UNCHANNELLED_FURY,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.ROTSPAWN],
        badge: RACE.KHORNE_CAREER,
        range: 6,
        cost: 160,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.LIZARDMEN_SKINK_2025]: {
        MA: 8,
        ST: 2,
        AG: 3,
        PA: 2,
        AV: 7,
        normal: "A",
        double: "GDPS",
        normalCoach: "G",
        icons: ["lizardmen-skink1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.STUNTY
        ],
        avatars: [AVATAR.LIZARDMEN],
        badge: RACE.LIZARDMEN_CAREER,
        range: 0,
        cost: 60,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.LIZARDMEN_CHAMELEON_2025]: {
        MA: 7,
        ST: 2,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "AP",
        double: "GDS",
        normalCoach: "G",
        icons: ["lizardmen-chameleon1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.ON_THE_BALL,
            skill_1.SKILL_NAMES.SHADOWING,
            skill_1.SKILL_NAMES.STUNTY,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.LIZARDMEN],
        badge: RACE.LIZARDMEN_CAREER,
        range: 1,
        cost: 70,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.LIZARDMEN_SAURUS_2025]: {
        MA: 6,
        ST: 4,
        AG: 1,
        PA: -1,
        AV: 9,
        normal: "GS",
        double: "A",
        normalCoach: "G",
        icons: ["lizardmen-saurus1"],
        skills: [
            skill_1.SKILL_NAMES.JUGGERNAUT,
            skill_1.SKILL_NAMES.UNSTEADY,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.LIZARDMEN],
        badge: RACE.LIZARDMEN_CAREER,
        range: 2,
        cost: 90,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.LIZARDMEN_KROXIGOR_2025]: {
        MA: 6,
        ST: 5,
        AG: 1,
        PA: -1,
        AV: 9,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["lizardmen-kroxigor1"],
        skills: [
            skill_1.SKILL_NAMES.BONE_HEAD,
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.PREHENSILE_TAIL,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.LIZARDMEN],
        badge: RACE.LIZARDMEN_CAREER,
        range: 6,
        cost: 140,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NECROMANTIC_HORROR_ZOMBIE_2025]: {
        MA: 4,
        ST: 3,
        AG: 2,
        PA: -1,
        AV: 8,
        normal: "DG",
        double: "AS",
        normalCoach: "G",
        icons: ["necromantic-zombie1"],
        skills: [
            skill_1.SKILL_NAMES.EYE_GOUGE,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.UNSTEADY
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.NECROMANTIC_CAREER,
        range: 0,
        cost: 40,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NECROMANTIC_HORROR_GHOUL_2025]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "AG",
        double: "DPS",
        normalCoach: "G",
        icons: ["necromantic-ghoul1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.NECROMANTIC_CAREER,
        range: 1,
        cost: 75,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NECROMANTIC_HORROR_WRAITH_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: -1,
        AV: 8,
        normal: "GS",
        double: "AD",
        normalCoach: "G",
        icons: ["necromantic-wraith1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.FOUL_APPEARANCE,
            skill_1.SKILL_NAMES.NO_HANDS,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.SIDESTEP,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.NECROMANTIC_CAREER,
        range: 2,
        cost: 85,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NECROMANTIC_HORROR_FLESH_GOLEM_2025]: {
        MA: 4,
        ST: 4,
        AG: 2,
        PA: -1,
        AV: 9,
        normal: "GS",
        double: "AD",
        normalCoach: "G",
        icons: ["necromantic-golem1"],
        skills: [
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.STAND_FIRM,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.UNSTEADY,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.GOLEM],
        badge: RACE.NECROMANTIC_CAREER,
        range: 3,
        cost: 110,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NECROMANTIC_HORROR_WEREWOLF_2025]: {
        MA: 8,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "AG",
        double: "DPS",
        normalCoach: "G",
        icons: ["necromantic-werewolf1"],
        skills: [
            skill_1.SKILL_NAMES.CLAW,
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.STAR
        ],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.NECROMANTIC_CAREER,
        range: 5,
        cost: 120,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NORSE_RAIDER_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 7,
        normal: "G",
        double: "APS",
        normalCoach: "G",
        icons: ["norse-lineman1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.DRUNKARD,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.UNSTEADY
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.NORSE_CAREER,
        range: 0,
        cost: 50,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NORSE_BERSERKER_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 1,
        AV: 7,
        normal: "GS",
        double: "AP",
        normalCoach: "G",
        icons: ["norse-berserker1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.JUMP_UP,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.NORSE_CAREER,
        range: 1,
        cost: 90,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NORSE_VALKYRIE_2025]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "AGP",
        double: "S",
        normalCoach: "G",
        icons: ["norse-catcher1"],
        skills: [
            skill_1.SKILL_NAMES.CATCH,
            skill_1.SKILL_NAMES.DAUNTLESS,
            skill_1.SKILL_NAMES.PASS,
            skill_1.SKILL_NAMES.STRIP_BALL,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.NORSE_CAREER,
        range: 2,
        cost: 95,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NORSE_ULFWERNER_2025]: {
        MA: 6,
        ST: 4,
        AG: 2,
        PA: -1,
        AV: 8,
        normal: "GS",
        double: "A",
        normalCoach: "G",
        icons: ["norse-ulfwereners1"],
        skills: [
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.UNSTEADY,
            skill_1.SKILL_NAMES.STAR
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.NORSE_CAREER,
        range: 5,
        cost: 105,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NORSE_YHETEE_2025]: {
        MA: 5,
        ST: 5,
        AG: 2,
        PA: -1,
        AV: 8,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["norse-yhetee1"],
        skills: [
            skill_1.SKILL_NAMES.CLAW,
            skill_1.SKILL_NAMES.DISTURBING_PRESENCE,
            skill_1.SKILL_NAMES.FRENZY,
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.UNCHANNELLED_FURY,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.YHETEE],
        badge: RACE.NORSE_CAREER,
        range: 6,
        cost: 140,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NURGLE_ROTTER_2025]: {
        MA: 5,
        ST: 3,
        AG: 2,
        PA: -1,
        AV: 8,
        normal: "DGM",
        double: "AS",
        normalCoach: "G",
        icons: ["nurgle-rotter1"],
        skills: [
            skill_1.SKILL_NAMES.DECAY,
            skill_1.SKILL_NAMES.PLAGUE_RIDDEN
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.NURGLE_CAREER,
        range: 0,
        cost: 40,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NURGLE_PESTIGOR_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 8,
        normal: "GMS",
        double: "ADP",
        normalCoach: "G",
        icons: ["nurgle-pestigor1"],
        skills: [
            skill_1.SKILL_NAMES.HORNS,
            skill_1.SKILL_NAMES.PLAGUE_RIDDEN,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.STEADY_FOOTING,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.BEASTMAN],
        badge: RACE.NURGLE_CAREER,
        range: 1,
        cost: 70,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NURGLE_BLOATER_2025]: {
        MA: 4,
        ST: 4,
        AG: 2,
        PA: -1,
        AV: 9,
        normal: "GMS",
        double: "AD",
        normalCoach: "G",
        icons: ["nurgle-bloater1"],
        skills: [
            skill_1.SKILL_NAMES.DISTURBING_PRESENCE,
            skill_1.SKILL_NAMES.FOUL_APPEARANCE,
            skill_1.SKILL_NAMES.PLAGUE_RIDDEN,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.STAND_FIRM,
            skill_1.SKILL_NAMES.UNSTEADY,
            skill_1.SKILL_NAMES.STAR
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.NURGLE_CAREER,
        range: 5,
        cost: 110,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.NURGLE_ROTSPAWN_2025]: {
        MA: 4,
        ST: 5,
        AG: 1,
        PA: -1,
        AV: 9,
        normal: "S",
        double: "DGM",
        normalCoach: "G",
        icons: ["nurgle-rotspawn1"],
        skills: [
            skill_1.SKILL_NAMES.DISTURBING_PRESENCE,
            skill_1.SKILL_NAMES.FOUL_APPEARANCE,
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.PICK_ME_UP,
            skill_1.SKILL_NAMES.PLAGUE_RIDDEN,
            skill_1.SKILL_NAMES.REALLY_STUPID,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.TENTACLES,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.ROTSPAWN],
        badge: RACE.NURGLE_CAREER,
        range: 6,
        cost: 140,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.ORC_LINEMAN_2025]: {
        MA: 5,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 9,
        normal: "GS",
        double: "AD",
        normalCoach: "G",
        icons: ["orc1"],
        skills: [],
        avatars: [AVATAR.ORC],
        badge: RACE.ORC_CAREER,
        range: 0,
        cost: 50,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.ORC_THROWER_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GP",
        double: "ADS",
        normalCoach: "G",
        icons: ["orc-thrower1"],
        skills: [
            skill_1.SKILL_NAMES.PASS,
            skill_1.SKILL_NAMES.SURE_HANDS,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ORC],
        badge: RACE.ORC_CAREER,
        range: 1,
        cost: 75,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.ORC_BLITZER_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 9,
        normal: "GS",
        double: "AD",
        normalCoach: "G",
        icons: ["orc-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.BREAK_TACKLE,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ORC],
        badge: RACE.ORC_CAREER,
        range: 2,
        cost: 85,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.ORC_BIG_UN_2025]: {
        MA: 5,
        ST: 4,
        AG: 2,
        PA: -1,
        AV: 9,
        normal: "GS",
        double: "AD",
        normalCoach: "G",
        icons: ["orc-black-orc1"],
        skills: [
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.TAUNT,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.UNSTEADY,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ORC],
        badge: RACE.ORC_CAREER,
        range: 3,
        cost: 95,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.ORC_TROLL_2025]: {
        MA: 4,
        ST: 5,
        AG: 1,
        PA: 1,
        AV: 9,
        normal: "S",
        double: "AGP",
        normalCoach: "G",
        icons: ["orc-troll1"],
        skills: [
            skill_1.SKILL_NAMES.ALWAYS_HUNGRY,
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.PROJECTILE_VOMIT,
            skill_1.SKILL_NAMES.REALLY_STUPID,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.THROW_TEAM_MATE,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.TROLL],
        badge: RACE.ORC_CAREER,
        range: 6,
        cost: 115,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SHAMBLING_UNDEAD_SKELETON_2025]: {
        MA: 5,
        ST: 3,
        AG: 2,
        PA: -1,
        AV: 7,
        normal: "G",
        double: "ADS",
        normalCoach: "G",
        icons: ["undead-skeleton1"],
        skills: [
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.THICK_SKULL
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.UNDEAD_CAREER,
        range: 0,
        cost: 40,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SHAMBLING_UNDEAD_ZOMBIE_2025]: {
        MA: 4,
        ST: 3,
        AG: 2,
        PA: -1,
        AV: 8,
        normal: "DG",
        double: "AS",
        normalCoach: "G",
        icons: ["undead-zombie1"],
        skills: [
            skill_1.SKILL_NAMES.EYE_GOUGE,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.UNSTEADY
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.UNDEAD_CAREER,
        range: 1,
        cost: 40,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SHAMBLING_UNDEAD_GHOUL_2025]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "AG",
        double: "DPS",
        normalCoach: "G",
        icons: ["undead-ghoul1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.UNDEAD_CAREER,
        range: 2,
        cost: 75,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SHAMBLING_UNDEAD_WIGHT_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 1,
        AV: 8,
        normal: "GS",
        double: "AD",
        normalCoach: "G",
        icons: ["undead-wight1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.TACKLE,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.UNDEAD_CAREER,
        range: 3,
        cost: 95,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SHAMBLING_UNDEAD_MUMMY_2025]: {
        MA: 3,
        ST: 5,
        AG: 1,
        PA: -1,
        AV: 9,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["undead-mummies1"],
        skills: [
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.UNDEAD_CAREER,
        range: 6,
        cost: 125,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SKAVEN_CLANRAT_2025]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 7,
        normal: "DG",
        double: "AMS",
        normalCoach: "G",
        icons: ["rat1"],
        skills: [],
        avatars: [AVATAR.RAT],
        badge: RACE.RAT_CAREER,
        range: 0,
        cost: 50,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SKAVEN_THROWER_2025]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 4,
        AV: 7,
        normal: "GP",
        double: "ADMS",
        normalCoach: "G",
        icons: ["rat-thrower1"],
        skills: [
            skill_1.SKILL_NAMES.PASS,
            skill_1.SKILL_NAMES.SURE_HANDS,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.RAT],
        badge: RACE.RAT_CAREER,
        range: 1,
        cost: 80,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SKAVEN_GUTTER_2025]: {
        MA: 9,
        ST: 2,
        AG: 4,
        PA: 2,
        AV: 7,
        normal: "ADG",
        double: "MS",
        normalCoach: "G",
        icons: ["rat-runner1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.STAB,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.RAT],
        badge: RACE.RAT_CAREER,
        range: 2,
        cost: 85,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SKAVEN_BLITZER_2025]: {
        MA: 8,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 8,
        normal: "GS",
        double: "ADM",
        normalCoach: "G",
        icons: ["rat-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.STRIP_BALL,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.RAT],
        badge: RACE.RAT_CAREER,
        range: 3,
        cost: 90,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SKAVEN_RAT_OGRE_2025]: {
        MA: 6,
        ST: 5,
        AG: 2,
        PA: -1,
        AV: 8,
        normal: "S",
        double: "AGM",
        normalCoach: "G",
        icons: ["rat-ogre1"],
        skills: [
            skill_1.SKILL_NAMES.ANIMAL_SAVAGERY,
            skill_1.SKILL_NAMES.FRENZY,
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.PREHENSILE_TAIL,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.RAT],
        badge: RACE.RAT_CAREER,
        range: 6,
        cost: 150,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SLANN_LINEMAN_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 8,
        normal: "G",
        double: "AS",
        normalCoach: "G",
        icons: ["slann-lineman1"],
        skills: [
            skill_1.SKILL_NAMES.POGO_STICK
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.SLANN_CAREER,
        range: 0,
        cost: 60,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SLANN_CATCHER_2025]: {
        MA: 7,
        ST: 2,
        AG: 4,
        PA: 2,
        AV: 7,
        normal: "AG",
        double: "SP",
        normalCoach: "G",
        icons: ["slann-catcher1"],
        skills: [
            skill_1.SKILL_NAMES.POGO_STICK,
            skill_1.SKILL_NAMES.DIVING_CATCH,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.SLANN_CAREER,
        range: 1,
        cost: 80,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SLANN_BLITZER_2025]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 8,
        normal: "AGS",
        double: "P",
        normalCoach: "G",
        icons: ["slann-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.POGO_STICK,
            skill_1.SKILL_NAMES.DIVING_TACKLE,
            skill_1.SKILL_NAMES.JUMP_UP,
            skill_1.SKILL_NAMES.STAR
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.SLANN_CAREER,
        range: 5,
        cost: 110,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SLANN_KROXIGOR_2025]: {
        MA: 6,
        ST: 5,
        AG: 1,
        PA: -1,
        AV: 9,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["slann-kroxigor1"],
        skills: [
            skill_1.SKILL_NAMES.BONE_HEAD,
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.PREHENSILE_TAIL,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.SLANN_CAREER,
        range: 6,
        cost: 140,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SNOTLING_LINEMAN_2025]: {
        MA: 5,
        ST: 1,
        AG: 3,
        PA: 2,
        AV: 5,
        normal: "AD",
        double: "G",
        normalCoach: "G",
        icons: ["snotling-lineman1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            // SKILL_NAMES.INSIGNIFICANT,,
            skill_1.SKILL_NAMES.RIGHT_STUFF,
            skill_1.SKILL_NAMES.SIDESTEP,
            skill_1.SKILL_NAMES.STUNTY,
            skill_1.SKILL_NAMES.TITCHY
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.SNOTLING_CAREER,
        range: 0,
        cost: 15,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SNOTLING_HOPPA_2025]: {
        MA: 6,
        ST: 1,
        AG: 3,
        PA: 2,
        AV: 5,
        normal: "AD",
        double: "G",
        normalCoach: "G",
        icons: ["snotling-runner1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.POGO_STICK,
            skill_1.SKILL_NAMES.RIGHT_STUFF,
            skill_1.SKILL_NAMES.SIDESTEP,
            skill_1.SKILL_NAMES.STUNTY,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.SNOTLING_CAREER,
        range: 1,
        cost: 20,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SNOTLING_RUNNA_2025]: {
        MA: 6,
        ST: 1,
        AG: 3,
        PA: 2,
        AV: 5,
        normal: "AD",
        double: "G",
        normalCoach: "G",
        icons: ["snotling-lineman1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.RIGHT_STUFF,
            skill_1.SKILL_NAMES.SIDESTEP,
            skill_1.SKILL_NAMES.SPRINT,
            skill_1.SKILL_NAMES.STUNTY,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.SNOTLING_CAREER,
        range: 2,
        cost: 20,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SNOTLING_PUMP_WAGON_2025]: {
        MA: 5,
        ST: 5,
        AG: 1,
        PA: -1,
        AV: 8,
        normal: "DS",
        double: "AG",
        normalCoach: "G",
        icons: ["snotling-wagon1"],
        skills: [
            skill_1.SKILL_NAMES.DIRTY_PLAYER,
            skill_1.SKILL_NAMES.JUGGERNAUT,
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.REALLY_STUPID,
            skill_1.SKILL_NAMES.STAND_FIRM,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.SNOTLING_CAREER,
        range: 3,
        cost: 100,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.SNOTLING_TROLL_2025]: {
        MA: 4,
        ST: 5,
        AG: 1,
        PA: 1,
        AV: 9,
        normal: "S",
        double: "AGP",
        normalCoach: "G",
        icons: ["snotling-troll1"],
        skills: [
            skill_1.SKILL_NAMES.ALWAYS_HUNGRY,
            skill_1.SKILL_NAMES.MIGHTY_BLOW,
            skill_1.SKILL_NAMES.PROJECTILE_VOMIT,
            skill_1.SKILL_NAMES.REALLY_STUPID,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.THROW_TEAM_MATE,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.TROLL],
        badge: RACE.SNOTLING_CAREER,
        range: 6,
        cost: 115,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.VAMPIRE_THRALL_2025]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 2,
        AV: 7,
        normal: "G",
        double: "AS",
        normalCoach: "G",
        icons: ["vampire-thrall1"],
        skills: [],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.VAMPIRE_CAREER,
        range: 0,
        cost: 40,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.VAMPIRE_RUNNER_2025]: {
        MA: 8,
        ST: 3,
        AG: 4,
        PA: 3,
        AV: 7,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["vampire-vampire1"],
        skills: [
            [skill_1.SKILL_NAMES.BLOODLUST, 2],
            skill_1.SKILL_NAMES.HYPNOTIC_GAZE,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.VAMPIRE_CAREER,
        range: 1,
        cost: 100,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.VAMPIRE_THROWER_2025]: {
        MA: 6,
        ST: 4,
        AG: 4,
        PA: 4,
        AV: 8,
        normal: "AGP",
        double: "S",
        normalCoach: "G",
        icons: ["vampire-vampire1"],
        skills: [
            [skill_1.SKILL_NAMES.BLOODLUST, 2],
            skill_1.SKILL_NAMES.HYPNOTIC_GAZE,
            skill_1.SKILL_NAMES.PASS,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.STAR
        ],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.VAMPIRE_CAREER,
        range: 5,
        cost: 110,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.VAMPIRE_BLITZER_2025]: {
        MA: 6,
        ST: 4,
        AG: 4,
        PA: 2,
        AV: 8,
        normal: "AGS",
        double: "",
        normalCoach: "G",
        icons: ["vampire-vampire1"],
        skills: [
            [skill_1.SKILL_NAMES.BLOODLUST, 3],
            skill_1.SKILL_NAMES.HYPNOTIC_GAZE,
            skill_1.SKILL_NAMES.JUGGERNAUT,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.VAMPIRE_CAREER,
        range: 2,
        cost: 110,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.VAMPIRE_VARGHEIST_2025]: {
        MA: 5,
        ST: 5,
        AG: 2,
        PA: -1,
        AV: 9,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["vampire-vampire1"],
        skills: [
            [skill_1.SKILL_NAMES.BLOODLUST, 3],
            skill_1.SKILL_NAMES.CLAW,
            skill_1.SKILL_NAMES.FRENZY,
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.BIG_GUY
        ],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.VAMPIRE_CAREER,
        range: 6,
        cost: 150,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.WOOD_ELF_LINEMAN_2025]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 3,
        AV: 7,
        normal: "AG",
        double: "S",
        normalCoach: "G",
        icons: ["silvan1"],
        skills: [],
        avatars: [AVATAR.ELF],
        badge: RACE.SILVAN_CAREER,
        range: 0,
        cost: 65,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.WOOD_ELF_THROWER_2025]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "AGP",
        double: "S",
        normalCoach: "G",
        icons: ["silvan-thrower1"],
        skills: [
            skill_1.SKILL_NAMES.PASS,
            skill_1.SKILL_NAMES.SAFE_PAIR_OF_HANDS,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.SILVAN_CAREER,
        range: 1,
        cost: 85,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.WOOD_ELF_CATCHER_2025]: {
        MA: 8,
        ST: 2,
        AG: 4,
        PA: 3,
        AV: 7,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["silvan-catcher1"],
        skills: [
            skill_1.SKILL_NAMES.CATCH,
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.SPRINT,
            skill_1.SKILL_NAMES.SPECIALIST
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.SILVAN_CAREER,
        range: 2,
        cost: 90,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
    [CAREER_ID.WOOD_ELF_WARDANCER_2025]: {
        MA: 8,
        ST: 3,
        AG: 4,
        PA: 3,
        AV: 7,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["silvan-wardancer1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.LEAP,
            skill_1.SKILL_NAMES.STAR
        ],
        avatars: [AVATAR.ELF],
        badge: RACE.SILVAN_CAREER,
        range: 5,
        cost: 130,
        hasSprite: false,
        version: CAREER_VERSION.V2025,
    },
};
const getCareers = () => {
    return CAREER;
};
exports.getCareers = getCareers;
